import { render, staticRenderFns } from "./CatalogItemPage.vue?vue&type=template&id=c97d75ce&scoped=true&"
import script from "./CatalogItemPage.vue?vue&type=script&lang=ts&"
export * from "./CatalogItemPage.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogItemPage.vue?vue&type=style&index=0&id=c97d75ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97d75ce",
  null
  
)

export default component.exports